module.exports = __webpack_public_path__ + "media/images/icon_list/pin_pinned-8c1758496eb914175c2d935a780387ff.svg";